import React from 'react'
import "./visionary.scss"
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Visionary = () => {
  const { t } = useTranslation()
  return (
    <>
      <section className="visionary-section">
        <video
          className="main-banner-video"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="\assets\videos\rays.mp4" type="video/mp4" />
        </video>
        <div className="custom-container">
            <div className="parent">
               <div className="right-side">
                    <h4>{t('Vision4')}</h4>
                </div>
                <div className="left-side">
                    <div className="main-content">
                        <h6>{t('Vision1')} </h6>
                        <p>{t('Vision2')}</p>
                        <Link to="/signupforproject" className='btn-green'>{t('Vision3')}</Link>
                    </div>
                </div>
               
            </div>
        </div>
      </section>
    </>
  )
}

export default Visionary
